import { render, staticRenderFns } from "./security-center.vue?vue&type=template&id=560b166b&scoped=true&"
import script from "./security-center.vue?vue&type=script&lang=js&"
export * from "./security-center.vue?vue&type=script&lang=js&"
import style0 from "./security-center.vue?vue&type=style&index=0&id=560b166b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560b166b",
  null
  
)

export default component.exports